import * as React from "react";
import { Market, Selection } from "../../../../../../contracts";
import { isMarketType, getDictPhrase } from "../../../../../../helpers";
import { EventCardProps, BetBtnRegular } from "../../../../components";

export const renderBetButtonsRegular = (market: Market, betButtonHandler: (market: Market, selection: Selection) => void, cardProps: EventCardProps, componentPrefix: string) => {
    return (
        <div key={`${componentPrefix}__${market.id}`} className={`rj-ev-list__ev-card__section rj-ev-list__ev-card__section--${market.template}`} data-uat={`div-ev-list-${componentPrefix}-section`}>
            { market.selections && market.selections.map(
                (s, index) => {
                    const betslipModifier = s.isSelectionInBetslip ? "rj-ev-list__bet-btn--chosen" : "";
                    const title = getSelectionName(cardProps, market, s);

                    return (
                        <BetBtnRegular
                            key={`${componentPrefix}__bet-btn__${market.id || "m"}-${s && s.id || "s"}-${index}`}
                            isDisabled={s.isDisabled}
                            classNames={betslipModifier}
                            handler={() => betButtonHandler(market as Market, s as Selection)}
                            text={title}
                            point={s.pointsText}
                            odd={s.odds}
                            trueOdds={s.trueOdds}
                        />
                    )
                }
            )}
        </div>
    );
}

export const getSelectionName = (cardProps: EventCardProps, market: Market, selection: Selection): string => {
    if (isMarketType(market.marketType.id, "HC") && !cardProps.isDesktop) {
        return "";
    }

    if (isMarketType(market.marketType.id, "ML")
        && !cardProps.showMLTeamName
        && selection.outcomeType !== null
    ) {
        return getDictPhrase(cardProps.dict, selection.outcomeType);
    }

    return selection.name;
}